// extracted by mini-css-extract-plugin
export var avatarContainer = "_3u-1";
export var largeAvatarContainer = "_3u-2";
export var smallAvatarContainer = "_3u-0";